<template>
    <BaseForm v-if="project">
        <template #fields>
            <TextField
                :value="values.category"
                :label="$t('project-category')"
                :error-messages="errors.category"
                @input="setFieldValue('category', ($event.target as HTMLInputElement).value)"
                @blur="setFieldTouched('category', true)"
            />
            <TextField
                :value="values.type"
                :label="$t('project-type')"
                :error-messages="errors.type"
                @input="setFieldValue('type', ($event.target as HTMLInputElement).value)"
                @blur="setFieldTouched('type', true)"
            />
        </template>
    </BaseForm>
</template>
<script setup lang="ts">
import BaseForm from '@/components/Form/BaseForm.vue';
import TextField from '@/components/Form/TextField.vue';
import { useForm } from '@/forms/composables/useForm';
import { useProjectInjection } from '@/project/composables/useProjectInjection';
import { ProjectSeriesTypeDefSchema } from '@/project/schemas';
import { computed } from 'vue';

const props = defineProps<{ projectId: string }>();

const projectId = computed(() => props.projectId);
const { project, updateProject } = useProjectInjection();

const { errors, values, setFieldValue, setFieldTouched, validate, onDiscard, resetForm } = useForm(
    ProjectSeriesTypeDefSchema,
    computed(() => ({
        category: project.value?.category,
        type: project.value?.type,
    })),
);

async function save() {
    const valid = await validate();
    if (valid) {
        await updateProject({ id: projectId.value, ...values.value });
    }
}

defineExpose({ save, onDiscard, resetForm });
</script>
